import request from '@/utils/request'


//查询任务设置
export function queryClassroom(data) {
  return request({
    url: '/admin/classroom/search',
    method: 'post',
    data: data
  })
}

export function addClassroom(data) {
  return request({
    url: '/admin/classroom/addClassroom',
    method: 'post',
    data: data
  })
}

export function delClassroom(params) {
  return request({
    url: '/admin/classroom/deleteClassroom',
    method: 'get',
    params: params
  })
}

export function updateClassroom(data) {
  return request({
    url: '/admin/classroom/updateClassroom',
    method: 'post',
    data: data
  })
}

//查询所有教室
export function selectAll(params) {
  return request({
    url: '/admin/classroom/selectAll',
    method: 'get',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/Classroom.js